module.exports = __webpack_public_path__ + "static/iso-7223ac78fa1096e39d7e842a85db125b.png";